import React from "react";
import { useTags } from "../../Tags";

const InitialTagsLoader: React.FC = () => {
  useTags();
  return <></>;
};

export default InitialTagsLoader;
